import { render, staticRenderFns } from "./OrderScreen.vue?vue&type=template&id=77aa00a7&scoped=true"
import script from "./OrderScreen.vue?vue&type=script&lang=js"
export * from "./OrderScreen.vue?vue&type=script&lang=js"
import style0 from "./OrderScreen.vue?vue&type=style&index=0&id=77aa00a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aa00a7",
  null
  
)

export default component.exports